module.exports = __webpack_public_path__ + "img/mikrotik.a87ca1bd.jpg";